import type axios from 'axios'

type Axios = typeof axios

let axiosPromise: Promise<Axios> | undefined

export const getAxios = (): Promise<Axios> => {
  axiosPromise ??= import('axios')
    .then(({ default: axios }) => axios)
    .catch(error => {
      axiosPromise = undefined
      throw error
    })
  return axiosPromise
}
